/**
 * LakikaveriStep — step 1 content (016 Onboarding Wizard, spec FR-002).
 *
 * Placeholder illustration per spec OQ-03; copy lives in the i18n bundle
 * (`onboarding.step.lakikaveri.title|body`).
 */

import type { JSX } from 'react';

import lakikaveriIllustration from '../../assets/onboarding-legal.png';

const imageClasses = 'w-full h-auto max-h-onboarding-illustration object-contain rounded-2xl';

export function LakikaveriStep(): JSX.Element {
  return <img src={lakikaveriIllustration} alt="" className={imageClasses} draggable={false} />;
}
